import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'cTUnlinkTot';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaUnlink',
		label: labels.groupAuditUnlinked,
		prop,
		width: 'minmax(var(--px-130), 1fr)'
	});
